// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var Types = {};

var Autosizer = {};

var FixedSizeInstance = {};

var VariableSizeInstance = {};

function InfiniteLoader(Instance) {
  return {};
}

var FixedSizeList = {};

var VariableSizeList = {};

exports.Types = Types;
exports.Autosizer = Autosizer;
exports.FixedSizeInstance = FixedSizeInstance;
exports.VariableSizeInstance = VariableSizeInstance;
exports.InfiniteLoader = InfiniteLoader;
exports.FixedSizeList = FixedSizeList;
exports.VariableSizeList = VariableSizeList;
/* No side effect */
